<template>
  <div>
    <BaseTopLine></BaseTopLine>

    <div class="tw-relative">
      <VueTabs
        class="vue-tabs-type-1"
        v-model="activateTab"
        @tab-change="handleTabChange"
      >
        <VTab
          :title="dataLang['city_delivery_register_text_1']"
          data-name="places"
        >
          <div v-if="dataLang['city_delivery_register_text_1'] == activateTab">
            <div
              class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mt-[15px]"
              :key="counter"
            >
              <div class="tw-flex tw-items-end tw-gap-[20px] tw-text-white">
                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["city_delivery_register_text_7"] }}
                  </label>
                  <BaseInputNew
                    @keyupEnter="clickLoadData(1, 'places')"
                    inputClass="tw-app-input-dark"
                    @input="fillFilter"
                    :additionalParams="{ type: 'like' }"
                    inputName="vehicle_places__id"
                  />
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["city_delivery_register_text_8"] }}
                  </label>
                  <BaseSelect
                    class="multiselect-type-1"
                    v-model="selectsFilter.region"
                    @input="
                      (e, w) => {
                        if (
                          !filter.find(
                            (x) => x.field == 'vehicle_places__city_id'
                          )
                        ) {
                          filter.push({
                            field: 'vehicle_places__city_id',
                            value: e.cities__id,
                          });
                        } else {
                          filter[
                            filter.findIndex(
                              (x) => x.field == 'vehicle_places__city_id'
                            )
                          ].value = e.cities__id;
                        }
                      }
                    "
                    label="cities__name"
                    id="ads__id"
                    placeholder=""
                    selectLabel=""
                    deselectLabel=""
                    :options="this.selectsData.cities"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template>
                    <template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["city_delivery_register_text_10"] }}
                  </label>
                  <BaseSelect
                    class="multiselect-type-1"
                    v-model="selectsFilter.places"
                    @input="
                      (e, w) => {
                        if (
                          !filter.find((x) => x.field == 'vehicle_places__id')
                        ) {
                          filter.push({
                            field: 'vehicle_places__id',
                            value: e.vehicle_places__id,
                          });
                        } else {
                          filter[
                            filter.findIndex(
                              (x) => x.field == 'vehicle_places__id'
                            )
                          ].value = e.vehicle_places__id;
                        }
                      }
                    "
                    label="vehicle_places__name"
                    placeholder=""
                    id="ads__id"
                    selectLabel=""
                    deselectLabel=""
                    :options="selectsData.places"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template>
                    <template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["city_delivery_register_text_12"] }}
                  </label>
                  <BaseSelect
                    class="multiselect-type-1"
                    v-model="selectsFilter.open"
                    @input="
                      (e, w) => {
                        if (
                          !filter.find(
                            (x) => x.field == 'vehicle_places__is_open'
                          )
                        ) {
                          filter.push({
                            field: 'vehicle_places__is_open',
                            value: e.value,
                          });
                        } else {
                          filter[
                            filter.findIndex(
                              (x) => x.field == 'vehicle_places__is_open'
                            )
                          ].value = e.value;
                        }
                      }
                    "
                    label="label"
                    placeholder=""
                    id="ads__id"
                    selectLabel=""
                    deselectLabel=""
                    :options="[
                      {
                        label: 'Открытая',
                        value: 1,
                      },
                      {
                        label: 'Закрытая',
                        value: 0,
                      },
                    ]"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template>
                    <template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["city_delivery_register_text_13"] }}
                  </label>
                  <BaseSelect
                    class="multiselect-type-1"
                    v-model="selectsFilter.delivery"
                    @input="
                      (e, w) => {
                        if (
                          !filter.find(
                            (x) => x.field == 'vehicle_places__is_delivery'
                          )
                        ) {
                          filter.push({
                            field: 'vehicle_places__is_delivery',
                            value: e.value,
                          });
                        } else {
                          filter[
                            filter.findIndex(
                              (x) => x.field == 'vehicle_places__is_delivery'
                            )
                          ].value = e.value;
                        }
                      }
                    "
                    label="label"
                    placeholder=""
                    id="ads__id"
                    selectLabel=""
                    deselectLabel=""
                    :options="[
                      {
                        label: 'Да',
                        value: 1,
                      },
                      {
                        label: 'Нет',
                        value: 0,
                      },
                    ]"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template>
                    <template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>

                <div class="tw-flex tw-flex-row">
                  <button
                    type="button"
                    class="tw-app-btn-primary"
                    @click="clickLoadData(1, 'places')"
                  >
                    {{ dataLang["city_delivery_register_text_5"] }}
                  </button>
                  <button
                    type="button"
                    class="tw-app-btn-light tw-whitespace-nowrap"
                    @click="resetFilter('places')"
                  >
                    {{ dataLang["city_delivery_register_text_6"] }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="tw-px-[26px] tw-mt-[15px] tw-flex tw-items-center tw-gap-[10px]"
            >
              <button
                class="tw-app-btn-primary"
                @click="$modal.show('addPlaceModal')"
              >
                <img
                  :src="require(`@/assets/icons/addwhite.svg`)"
                  width="13.5"
                  height="13.5"
                  class="tw-my-[-5px]"
                />
                {{ dataLang["city_delivery_register_text_3"] }}
              </button>
              <button class="tw-app-btn-primary-outline" @click="acceptDelete">
                <img
                  :src="require(`@/assets/icons/adddel.svg`)"
                  width="13.5"
                  height="13.5"
                />
                {{ dataLang["city_delivery_register_text_4"] }}
              </button>
            </div>

            <div
              class="position-relative tw-px-[26px] tw-py-[15px] tw-min-h-[500px]"
            >
              <BaseLoader
                v-if="localLoading"
                class="tw-bg-[#fafbfc]"
              ></BaseLoader>

              <div class="tw-flex tw-justify-end tw-mb-[15px]">
                <TwBasePagination
                  :page-count="numPagesCities"
                  :pagination-params="{
                    ...paginationCitiesStateParams,
                    limit: limitPaginationValue,
                  }"
                  :showLimitInput="true"
                  @updateLimitValue="updateLimitValue"
                  :page-range="10"
                  :margin-pages="0"
                  :click-handler="(num) => clickLoadData(num, 'places')"
                >
                </TwBasePagination>
              </div>

              <ve-table
                class="fixed-header rest-style-table"
                style="width: 100%"
                :columns="columns"
                :table-data="dataTable"
                :border-x="true"
                :border-y="true"
                ref="refTable"
                row-key-field-name="vehicle_places__id"
                :eventCustomOption="eventCustomOption"
                :checkbox-option="checkboxOption"
                v-if="!localLoading"
                :clickHighlight="false"
                :rowStyleOption="{
                  hoverHighlight: true,
                }"
                :cellSelectionOption="{ enable: false }"
              />
            </div>
          </div>
          <BaseModal
            name="addPlaceModal"
            width="420"
            :clickToClose="false"
            @before-open="beforeOpen"
            @before-close="beforeClose"
            :shiftY="0.5"
            :adaptive="true"
            height="auto"
            classes="tw-app-modal"
          >
            <div class="tw-app-modal__container">
              <button
                type="button"
                class="btn-close tw-app-modal__close"
                @click="$modal.hide('addPlaceModal')"
              ></button>

              <div>
                <div class="tw-app-modal__title">
                  {{ dataLang.city_delivery_register_text_37 }}
                </div>

                <div class="tw-mb-[15px]" ref="vehicle_places__city_id">
                  <div class="multiselect-type-3-label">
                    {{ dataLang.city_delivery_register_text_8 }}
                  </div>
                  <BaseSelect
                    class="multiselect-type-3"
                    placeholder=""
                    selectLabel=""
                    deselectLabel=""
                    @input="
                      (data) => {
                        setSimpleSelect({
                          key: 'vehicle_places__city_id',
                          value: data.cities__id,
                        });
                        valueAddress = data.cities__name;
                      }
                    "
                    v-model="selectsFromModal.cities"
                    :options="selectsData.cities"
                    label="cities__name"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template
                    ><template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>

                <div class="tw-mb-[15px]" ref="vehicle_places__address">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang["city_delivery_register_text_38"] }}
                  </div>
                  <BaseInputNew
                    inputClass="tw-app-input-type-3"
                    placeholder=""
                    input-name="vehicle_places__address"
                    maxLength="100"
                    @input="updateValueCitiesCenter"
                    :horizontalTitle="true"
                    :value="valueAddress"
                    @selectData="onSelectFromAddress"
                    :additionalParams="{}"
                    name-sign=""
                    :options="addressOptions"
                    selectKey="formatted_address"
                    selectFocusmethod="input"
                  ></BaseInputNew>
                </div>

                <div class="tw-mb-[15px]" ref="vehicle_places__name">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang["city_delivery_register_text_10"] }}
                  </div>
                  <BaseInputNew
                    inputClass="tw-app-input-type-3"
                    input-name="vehicle_places__name"
                    maxLength="100"
                    @input="updateValue"
                    :horizontalTitle="true"
                    :additionalParams="{}"
                  ></BaseInputNew>
                </div>

                <div
                  class="tw-mb-[15px] tw-grid tw-grid-cols-[auto_200px] tw-items-center tw-gap-[10px]"
                  ref="vehicle_places__work_hours_start"
                >
                  <div class="">
                    {{ dataLang["city_delivery_register_text_23"] }}
                  </div>
                  <BaseDatePicker
                    class="tw-w-full"
                    input-class="tw-app-input-type-3"
                    v-model="selectTime.start"
                    type="time"
                    lang="ru"
                    id="vehicle_places__work_hours_start"
                    value-type="format"
                    :format="`HH:mm`"
                    @change="
                      (date) =>
                        updateValue({
                          name: 'vehicle_places__work_hours_start',
                          value: date,
                        })
                    "
                  >
                  </BaseDatePicker>
                </div>

                <div
                  class="tw-mb-[15px] tw-grid tw-grid-cols-[auto_200px] tw-items-center tw-gap-[10px]"
                  ref="vehicle_places__work_hours_end"
                >
                  <div class="">
                    {{ dataLang["city_delivery_register_text_24"] }}
                  </div>
                  <BaseDatePicker
                    class="tw-w-full"
                    input-class="tw-app-input-type-3"
                    v-model="selectTime.end"
                    type="time"
                    lang="ru"
                    id="vehicle_places__work_hours_end"
                    value-type="format"
                    :format="`HH:mm`"
                    @change="
                      (date) =>
                        updateValue({
                          name: 'vehicle_places__work_hours_end',
                          value: date,
                        })
                    "
                  >
                  </BaseDatePicker>
                </div>

                <div
                  class="tw-mb-[15px] tw-grid tw-grid-cols-[auto_200px] tw-items-center tw-gap-[10px]"
                  ref="vehicle_places__phone"
                >
                  <div class="">
                    {{ dataLang["city_delivery_register_text_11"] }}
                  </div>
                  <BaseInputNew
                    inputClass="tw-app-input-type-3"
                    input-name="vehicle_places__phone"
                    @input="updateValue"
                    :horizontalTitle="true"
                    inputRef="clients__phone"
                    inputMask="+{7}(000)000-00-00"
                    maxLength="16"
                  >
                  </BaseInputNew>
                </div>

                <div class="tw-mb-[15px]" ref="vehicle_places__is_open">
                  <div class="multiselect-type-3-label">
                    {{ dataLang.city_delivery_register_text_12 }}
                  </div>
                  <BaseSelect
                    class="multiselect-type-3"
                    placeholder=""
                    selectLabel=""
                    deselectLabel=""
                    @input="
                      (data) =>
                        updateValue({
                          name: 'vehicle_places__is_open',
                          value: data.value,
                        })
                    "
                    openDirection="bottom"
                    v-model="selectsData.isOpen"
                    :options="[
                      { label: dataLang['places_open_false'], value: 0 },
                      { label: dataLang['places_open_true'], value: 1 },
                    ]"
                    label="label"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template
                    ><template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>
              </div>

              <div class="tw-app-modal__footer">
                <button
                  @click="$modal.hide('addPlaceModal')"
                  class="tw-app-btn-muted tw-app-btn-muted-lg"
                >
                  Отмена
                </button>
                <button
                  @click="sendData"
                  class="tw-app-btn-primary tw-app-btn-primary-lg"
                >
                  Далее
                </button>
              </div>
            </div>
          </BaseModal>
        </VTab>
        <VTab
          :title="dataLang['city_delivery_register_text_2']"
          data-name="global"
        >
          <div v-if="dataLang['city_delivery_register_text_2'] == activateTab">
            <div
              class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mt-[15px] tw-text-white"
            >
              <div class="tw-flex tw-items-end tw-gap-[20px]">
                <div class="tw-app-input-container !tw-max-w-[265px]">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["global_register_text_1"] }}
                  </label>
                  <BaseSelect
                    class="multiselect-type-1"
                    placeholder=""
                    selectLabel=""
                    deselectLabel=""
                    style="width: 265px"
                    @input="
                      (data) => {
                        globalCity = data;
                        loadDataForGlobal(true);
                      }
                    "
                    v-model="globalCity"
                    :options="citiesGlobal"
                    label="cities__name"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template>
                    <template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>
              </div>
            </div>

            <div class="tw-px-[26px] tw-pt-[15px]">
              <button
                type="button"
                class="tw-app-btn-light tw-whitespace-nowrap !tw-text-[#0056AF]"
                @click="resetFilter"
              >
                {{ dataLang["city_delivery_register_text_6"] }}
              </button>

              <div class="tw-mt-[15px] tw-text-[14px]">
                Распределите города России относительно выбранного города
                площадки
              </div>
            </div>

            <div
              class="position-relative tw-px-[26px] tw-py-[15px] tw-min-h-[500px]"
            >
              <BaseLoader
                v-if="localLoading"
                class="tw-bg-[#fafbfc]"
              ></BaseLoader>

              <ve-table
                class="fixed-header rest-style-table"
                style="width: 100%"
                :columns="colGlobal"
                :table-data="globalData"
                :border-x="true"
                :border-y="true"
                ref="refTable"
                row-key-field-name="cities__id"
                v-if="!localLoading"
                :clickHighlight="false"
                :cell-style-option="{
                  headerCellClass: ({ column, rowIndex }) => {
                    return 'table-header-cell-class';
                  },
                }"
                :rowStyleOption="{
                  hoverHighlight: true,
                }"
                :cellSelectionOption="{ enable: false }"
              />
            </div>
          </div>
        </VTab>
      </VueTabs>
    </div>
    <BaseModal
      name="acceptDelete"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 py-25 px-20">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('acceptDelete')"
          ></button>
        </div>
        <p class="text-center">{{ dataLang.confirm_dialog_delete }}</p>
        <div class="d-flex justify-content-center mt-10">
          <div class="btn btn-sm btn-danger" @click="deleteRow">
            {{ dataLang.confirm_btn__btn_yes }}
          </div>
        </div>
      </div>
    </BaseModal>
    <PlacesModal></PlacesModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import GeneralService from "@/api/GeneralService";
import PlacesModal from "./places-modal/PlacesModal.vue";
import EventBus from "@/event-bus";
export default {
  components: {
    VeTable,
    VTab,
    VueTabs,
    PlacesModal,
  },

  props: {},
  data() {
    return {
      counter: 0,
      numOfList: 0,
      copyData: [],
      textparam: "12312",
      globalCity: {},
      globalData: [],
      updatedValues: {},
      dataTable: null,
      localLoading: true,
      activateTab: "",
      limitPaginationValue: 50,
      valueAddress: "",
      filter: [],
      activeSelectRowsMultiple: [],
      selectTime: { start: [], end: [] },
      citiesGlobal: [],
      addressOptions: [],
      selectsData: {
        countries: [],
        isOpen: [],
        region: [],
        cities: [],
        time: [],
        places: [],
      },
      letOnew: {
        one: [],
        two: [],
        three: [],
        four: [],
      },
      selectsFilter: {
        countries: [],
        region: [],
        time: [],
        region: [],
        cities: [],
        delivery: [],
        open: [],
        nones: [],
        sgs: [],
        sgf: [],
        sgt: [],
      },
      selectsFromModal: {
        countries: [],
        region: [],
        time: [],
        integrator: [],
      },
      currentOpenedId: null,
      checkboxOption: {
        // row select change event
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
        // selected all change event
        selectedAllChange: ({ row, isSelected, selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("placeEditModal", {
                id: row.vehicle_places__id,
              });
            },
          };
        },
      },
      timeout: null,
      valueAddress: "",
    };
  },
  methods: {
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.clickLoadData(1, "places");
    },
    updateValueCitiesCenter(e) {
      this.valueAddress = e.value;
      this.updatedValues.vehicle_places__address = e.value;
      this.addressOptions = [];
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        let data = await fetch(
          `https://suggest-maps.yandex.ru/v1/suggest?text=${e.value}&apikey=ebc56b08-9998-443e-99e9-e0a70c2cd1c1&print_address=1&types=country,house,house,district,geo,street,locality&lang=ru&results=15`
        );
        let dataFromJson = await data.json();
        dataFromJson.results.forEach((elem, index) => {
          this.addressOptions.push(elem.address);
        });
      }, 400);
    },
    onSelectFromAddress(e) {
      this.valueAddress = e.value.formatted_address;
      this.updatedValues.vehicle_places__address = e.value.formatted_address;
    },
    deleteRow() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(`/places/${this.activeSelectRowsMultiple}`)
          .then((data) => {
            this.clickLoadData(1, "places");
            this.$modal.hide("acceptDelete");
            this.$toast.success(data.data.message);
          })
          .catch((error) => {
            this.$toast.error(error.response.data.message, { duration: 5000 });
          });
      }
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$toast.error("Выберите хотя бы одно поле", { duration: 5000 });
      }
    },
    beforeClose() {
      for (const key in this.selectsFromModal) {
        this.selectsFromModal[key] = [];
      }
      this.updatedValues = {};
      this.openedType = "create";
      this.currentOpenedId = null;
      this.selectTime = { start: [], end: [] };
    },
    beforeOpen() {},
    sendData() {
      GeneralService.editOrCreate("/places", {
        ...this.updatedValues,
      })
        .then((data) => {
          this.clickLoadData(1, "places");
          this.$modal.hide("addPlaceModal");
          this.$toast.success(data.data.message);
          data.data.data.vehicle_places__id;
          this.$modal.show("placeEditModal", {
            id: data.data.data.vehicle_places__id,
          });
          this.updatedValues = {};
        })
        .catch((error) => {
          Object.keys(error.response.data.errors).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.add("input-error");
            }
          });
          this.$toast.error(error.response.data.message, { duration: 5000 });
        });
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      this.updatedValues = {};
      this.filter = [];
      if (newTab.$attrs["data-name"] == "places") {
        this.clickLoadData(1, newTab.$attrs["data-name"]);
      } else {
        this.loadDataForGlobal(true, true);
      }
    },
    clickLoadData(numPage, reestrType) {
      // this.limitPaginationValue = 50;
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/${reestrType}/table/main`, {
          params: {
            limit: this.limitPaginationValue,
            page: numPage,
            where: JSON.stringify(this.filter),
          },
        })
          .then((data) => {
            this.dataTable = data.data.rows;
            this.getCitiesAll(data.data);
          })
          .catch((error) => {}),
        GeneralService.get("/countries")
          .then((data) => {
            this.selectsData.countries = data.data.data.rows;
          })
          .catch((error) => {}),
        GeneralService.get("/regions")
          .then((data) => {
            this.selectsData.region = data.data.data.rows;
          })
          .catch((error) => {}),
        GeneralService.get("/places/cities?limit=5000")
          .then((data) => {
            this.selectsData.cities = data.data.data.rows;
          })
          .catch((error) => {}),
        GeneralService.get("/places")
          .then((data) => {
            this.selectsData.places = data.data.places.rows;
          })
          .catch((error) => {}),
      ]).then(() => {
        this.localLoading = false;
      });
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;

      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    setSimpleSelect(data, id) {
      this.updatedValues[data.key] = data.value;
      if (this.$refs[data.key]) {
        this.$refs[data.key].classList.remove("input-error");
      }
    },
    resetFilter(reestrType) {
      this.counter++;
      this.filter = [];
      this.selectsFilter = {
        countries: [],
        region: [],
        time: [],
        integrator: [],
        delivery: [],
        open: [],
      };
      if (reestrType == "places") {
        this.clickLoadData(1, reestrType);
      } else {
        this.loadDataForGlobal(true);
      }
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    onChangeNew(active, row) {
      GeneralService.edit(
        `/global/settings/${this.globalCity.global_cities__id}`,
        {
          global_cities_settings__city_id: row.cities__id,
          global_cities_settings__active: active,
        }
      )
        .then((data) => {
          // this.globalData = data.data.data.rows
          let index = this.globalData.findIndex(
            (x) => x.cities__id == row.cities__id
          );
          this.globalData[index].active = active;
        })
        .catch((error) => {});
    },
    loadDataForGlobal(e, isChangeCity) {
      if (e === true) {
        this.localLoading = true;
      }
      GeneralService.get(`/global/cities`, {
        params: {
          limit: 10000,
        },
      })
        .then((data) => {
          this.citiesGlobal = data.data.rows;
          if (isChangeCity) {
            this.globalCity = data.data.rows[0];
          }

          GeneralService.get(
            `/global/settings/${this.globalCity.global_cities__id}`,
            {
              params: {
                limit: 10000,
              },
            }
          )
            .then((data) => {
              this.globalData = data.data.data.rows;
              this.copyData = data.data.data.rows;
              if (e === true) {
                this.localLoading = false;
              }
            })
            .catch((error) => {});
        })
        .catch((error) => {});
    },
    ...mapActions("citiesPagiation", ["getCitiesAll"]),
  },
  mounted() {
    EventBus.$on("updateContentData", () => {
      this.clickLoadData(1, "places");
    });
    this.selectsData.isOpen = {
      label: this.dataLang["places_open_false"],
      value: 0,
    };
  },

  created() {
    this.clickLoadData(1, "places");
  },

  computed: {
    ...mapState("userSettingModule", ["userSetting", "countNotices"]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("citiesPagiation", ["paginationCitiesStateParams"]),
    ...mapGetters("citiesPagiation", ["numPagesCities"]),
    numPages() {
      return (
        this.paginationStateParams.total / this.paginationStateParams.limit
      );
    },

    colGlobal() {
      return [
        {
          field: "regions__name",
          title: this.dataLang["global_register_text_4"],
          align: "center",
          key: "2224",
          width: "14%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.region}
                  onInput={(e, w) => {
                    {
                      /* numOfList: 0, */
                    }
                    this.globalData = this.copyData.filter((x) => {
                      return x.regions__id == e.regions__id;
                    });
                  }}
                  style={"width: 100%"}
                  label={"regions__name"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.region}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "cities__name",
          title: this.dataLang["global_register_text_5"],
          width: "14%",
          align: "center",
          key: "224",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.cities}
                  onInput={(e, w) => {
                    this.globalData = this.copyData.filter((x) => {
                      return x.cities__name == e.cities__name;
                    });
                  }}
                  style={"width: 100%"}
                  label={"cities__name"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.cities}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          title: this.dataLang["global_register_text_6"],
          align: "center",
          key: "0008",
          width: "7%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.nones}
                  onInput={(e, w) => {
                    if (e.value) {
                      this.globalData = this.copyData.filter((x) => {
                        return x.active == "none";
                      });
                    }
                    if (e.value === 0) {
                      this.globalData = this.copyData.filter((x) => {
                        return (
                          x.active == "gs" ||
                          x.active == "gf" ||
                          x.active == "gt"
                        );
                      });
                    }
                    if (e.value === null) {
                      this.globalData = this.copyData;
                    }
                  }}
                  style={"width: 100%"}
                  label={"label"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={[
                    {
                      label: "Любой",
                      value: null,
                    },
                    {
                      label: "Да",
                      value: 1,
                    },
                    {
                      label: "Нет",
                      value: 0,
                    },
                  ]}
                ></BaseSelect>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div class={"d-flex justify-content-center"}>
                <BaseRadio
                  name={row.global_cities__city_id}
                  value={"none"}
                  vModel={row.active}
                  onChange={(e) => {
                    this.onChangeNew(row.active.value, row);
                  }}
                >
                  {""}
                </BaseRadio>
              </div>
            );
          },
        },
        {
          title: `${this.dataLang["global_register_text_7"]} \r\n ${this.dataLang["global_register_text_8"]}`,
          align: "center",
          key: "24724",
          width: "20%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>
                  {`${this.dataLang["global_register_text_7"]}`}
                  <BaseSelect
                    vModel={this.selectsFilter.sgs}
                    onInput={(e, w) => {
                      if (e.value) {
                        this.globalData = this.copyData.filter((x) => {
                          return x.active == "gs";
                        });
                      }
                      if (e.value === 0) {
                        this.globalData = this.copyData.filter((x) => {
                          return (
                            x.active == "none" ||
                            x.active == "gf" ||
                            x.active == "gt"
                          );
                        });
                      }
                      if (e.value === null) {
                        this.globalData = this.copyData;
                      }
                    }}
                    style={"width: 100%"}
                    label={"label"}
                    placeholder={""}
                    id={"ads__id"}
                    selectLabel={""}
                    deselectLabel={""}
                    options={[
                      {
                        label: "Любой",
                        value: null,
                      },
                      {
                        label: "Да",
                        value: 1,
                      },
                      {
                        label: "Нет",
                        value: 0,
                      },
                    ]}
                  ></BaseSelect>
                </div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div class={"d-flex justify-content-center"}>
                <BaseRadio
                  name={row.global_cities__city_id}
                  value={"gs"}
                  vModel={row.active}
                  onChange={(e) => {
                    this.onChangeNew(row.active.value, row);
                  }}
                >
                  {""}
                </BaseRadio>
              </div>
            );
          },
        },
        {
          title: this.dataLang["global_register_text_6"],
          align: "center",
          key: "42845",
          width: "20%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>
                  {`${this.dataLang["global_register_text_9"]}`}
                </div>
                <BaseSelect
                  vModel={this.selectsFilter.sgf}
                  onInput={(e, w) => {
                    if (e.value) {
                      this.globalData = this.copyData.filter((x) => {
                        return x.active == "gf";
                      });
                    }
                    if (e.value === 0) {
                      this.globalData = this.copyData.filter((x) => {
                        return (
                          x.active == "none" ||
                          x.active == "gs" ||
                          x.active == "gt"
                        );
                      });
                    }
                    if (e.value === null) {
                      this.globalData = this.copyData;
                    }
                  }}
                  style={"width: 100%"}
                  label={"label"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={[
                    {
                      label: "Любой",
                      value: null,
                    },
                    {
                      label: "Да",
                      value: 1,
                    },
                    {
                      label: "Нет",
                      value: 0,
                    },
                  ]}
                ></BaseSelect>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div class={"d-flex justify-content-center"}>
                <BaseRadio
                  name={row.global_cities__city_id}
                  value={"gf"}
                  vModel={row.active}
                  onChange={(e) => {
                    this.onChangeNew(row.active.value, row);
                  }}
                >
                  {""}
                </BaseRadio>
              </div>
            );
          },
        },
        {
          title: this.dataLang["global_register_text_6"],
          align: "center",
          key: "42445",
          width: "20%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>
                  {`${this.dataLang["global_register_text_11"]}`}
                </div>
                <BaseSelect
                  vModel={this.selectsFilter.sgt}
                  onInput={(e, w) => {
                    if (e.value) {
                      this.globalData = this.copyData.filter((x) => {
                        return x.active == "gt";
                      });
                    }
                    if (e.value === 0) {
                      this.globalData = this.copyData.filter((x) => {
                        return (
                          x.active == "gf" ||
                          x.active == "gs" ||
                          x.active == "none"
                        );
                      });
                    }
                    if (e.value === null) {
                      this.globalData = this.copyData;
                    }
                  }}
                  style={"width: 100%"}
                  label={"label"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={[
                    {
                      label: "Любой",
                      value: null,
                    },
                    {
                      label: "Да",
                      value: 1,
                    },
                    {
                      label: "Нет",
                      value: 0,
                    },
                  ]}
                ></BaseSelect>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div class={"d-flex justify-content-center"}>
                <BaseRadio
                  name={row.global_cities__city_id}
                  value={"gt"}
                  vModel={row.active}
                  onChange={(e) => {
                    this.onChangeNew(row.active.value, row);
                  }}
                >
                  {""}
                </BaseRadio>
              </div>
            );
          },
        },
      ];
    },

    // }
    columns() {
      return [
        {
          field: "",
          key: "aaa",
          type: "checkbox",
          title: "",
          align: "center",
          width: 30,
        },
        {
          field: "vehicle_places__id",
          title: this.dataLang["city_delivery_register_text_7"],
          key: "411",
          align: "left",
          width: "5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },

        {
          field: "cities__name",
          title: this.dataLang["city_delivery_register_text_8"],
          align: "left",
          key: "224",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "vehicle_places__address",
          title: this.dataLang["city_delivery_register_text_9"],
          align: "left",
          key: "232",
          width: "12%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "vehicle_places__name",
          title: this.dataLang["city_delivery_register_text_10"],
          align: "left",
          width: "15%",
          key: "454",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "vehicle_places__phone",
          title: this.dataLang["city_delivery_register_text_11"],
          align: "left",
          key: "3235",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "vehicle_places__is_open",
          title: this.dataLang["city_delivery_register_text_12"],
          align: "left",
          key: "5456",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div
                title={row.vehicle_places__is_open ? "Открытая" : "Закрытая"}
                class={"d-flex justify-content-center"}
              >
                {row.vehicle_places__is_open ? "Открытая" : "Закрытая"}
              </div>
            );
          },
        },
        {
          field: "vehicle_places__is_delivery",
          title: this.dataLang["city_delivery_register_text_13"],
          align: "left",
          key: "54526",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div
                title={row.vehicle_places__is_delivery ? "Да" : "Нет"}
                class={"d-flex justify-content-center"}
              >
                {row.vehicle_places__is_delivery ? "Да" : "Нет"}
              </div>
            );
          },
        },
        {
          field: "car",
          title: this.dataLang["city_delivery_register_text_14"],
          align: "left",
          key: "1134",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div
                title={
                  row.car?.split("/")?.[1]
                    ? "Емкость: " +
                      row.car?.split("/")[0] +
                      "  " +
                      "Занято: " +
                      row.car?.split("/")[1] +
                      "  " +
                      "Свободно: " +
                      (row.car?.split("/")[0] - row.car?.split("/")[1])
                    : "-"
                }
                class={"text-center"}
              >
                {row.car?.split("/")?.reverse()?.join("/")}
                {/* {row.car.split("/").map((e, index) => {
                  return (
                    <span
                      style={
                        index == 2 && row.car.split("/").lenght
                          ? "color: rgb(0, 86, 175);"
                          : ""
                      }
                      key={index}
                    >
                      {e}
                      {index < 2 ? "/" : ""}
                    </span>
                  );
                })} */}
              </div>
            );
          },
        },
        {
          field: "water",
          title: this.dataLang["city_delivery_register_text_21"],
          align: "left",
          key: "423343",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div
                title={
                  row.water?.split("/")?.[1]
                    ? "Емкость: " +
                      row.water?.split("/")[0] +
                      "  " +
                      "Занято: " +
                      row.water?.split("/")[1] +
                      "  " +
                      "Свободно: " +
                      (row.water?.split("/")[0] - row.water?.split("/")[1])
                    : "-"
                }
                class={"text-center"}
              >
                {row.water?.split("/")?.reverse()?.join("/")}
                {/* {row.water.split("/").map((e, index) => {
                  return (
                    <span
                      style={
                        index == 2 && row.water.split("/").lenght
                          ? "color: rgb(0, 86, 175);"
                          : ""
                      }
                      key={index}
                    >
                      {e}
                      {index < 2 ? "/" : ""}
                    </span>
                  );
                })} */}
              </div>
            );
          },
        },
        {
          field: "air",
          title: this.dataLang["city_delivery_register_text_20"],
          align: "left",
          key: "43413",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div
                title={
                  row.air?.split("/")?.[1]
                    ? "Емкость: " +
                      row.air?.split("/")[0] +
                      "  " +
                      "Занято: " +
                      row.air?.split("/")[1] +
                      "  " +
                      "Свободно: " +
                      (row.air?.split("/")[0] - row.water?.split("/")[1])
                    : "-"
                }
                class={"text-center"}
              >
                {row.air?.split("/")?.reverse()?.join("/")}
                {/* {row.air.split("/").map((e, index) => {
                  return (
                    <span
                      style={
                        index == 2 && row.air.split("/").lenght
                          ? "color: rgb(0, 86, 175);"
                          : ""
                      }
                      key={index}
                    >
                      {e}
                      {index < 2 ? "/" : ""}
                    </span>
                  );
                })} */}
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
